/* eslint-disable jira/naming/disallow-filenames */
const ufoNamesMap: Record<string, string> = {
	'project-settings-software-issuetypes': 'project-settings.issue-type.jsw-tmp',
	'project-settings-servicedesk-issuetypes': 'project-settings.issue-type.jsm-tmp',
};

export const getUFOName = (name: string): string => ufoNamesMap[name] || name;
